<template>
	<div>
		<div class="list">
			<filter-panel :data="setMealGroups" @search="filterChange"></filter-panel>
			<div class="button-area">
				<el-button class="setMeal-btn" type="primary" @click="addSetMeal">新增</el-button>
			</div>
			<data-list
				ref="list"
				:data="data"
				:columns="setMealColumn"
				:table-style="{ name: 'mixture' }"
				:page="page"
				:page-size="page.pageSize"
				:loading="loading"
				@expand-change="expandChange"
				@page-size-changed="pageSizeChanged"
				@page-changed="pageChanged"
				@sort-change="sortChange"
			></data-list>
		</div>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import setmeal from '@/backend/services/account/setmeal.js';

const list = listPageCreate({
	searchConfig: {
		api: api.setmeal.setMealLists,
		method: 'POST',
		config: {
			timeout: 60000,
		},
	},
});

export default {
	mixins: [list],
	props: ['setMealGroups', 'setMealColumn'],
	activated() {
		this.query();
	},
	provide() {
		//  0 全部线索  1 线索列表详情  2 公海线索  3 垃圾线索
		return {
			close: this.close,
			listQuery: this.query,
		};
	},
	methods: {
		addSetMeal() {
			this.$router.push({
				name: 'setMealConfig',
			});
		},
		expandChange({ row, arr }) {
			this.$nextTick(() => {
				if(this.$refs.list.$refs.historyVersionList){
          this.$refs.list.$refs.historyVersionList.$refs.historyVersionList.query(row)
        }
			});
		},
	},
	components: { filterPanel },
};
</script>

<style lang="scss" scoped>
.button-area {
	width: 100%;
	height: 60px;
	margin: 10px 0;
	padding: 0 20px;
	padding-bottom: 10px;
	background-color: #fff;
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
}
</style>
